<template>
  <div class="tags-performance-error-hint">
    <i class="tags-performance-error-hint-icon icon-font-exclamation" />
    <span class="tags-performance-error-hint-description">
      {{ description }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TagsPerformanceErrorHint',
  props: {
    description: {
      type: String,
      default: '很抱歉，載入數據發生錯誤 ...',
    },
  },
}
</script>

<style scoped lang="scss">
.tags-performance-error-hint {
  margin-top: 1.5rem;
  padding-bottom: 2rem;
  text-align: left;
  @media (min-width: 768px) {
    margin-top: 1rem;
    padding-bottom: 1.5rem;
    font-size: 13px;
  }
}
.tags-performance-error-hint-icon {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  font-weight: bold;
  border: 3px solid;
  text-align: center;
  color: #939393;
  border-radius: 50%;
  @media (min-width: 768px) {
    border-color: #ffe9e8;
    background-color: #ffe9e8;
    color: #ea5e5b;
  }

  &:before {
    line-height: inherit;
  }
}
</style>
